import React from 'react'
import { fnum } from '../../utils/utils'
import PRSEditCostForm from './PRSEditCostForm'
import PRSAddPmntForm from './PRSAddPmntForm'
import moment from 'moment'

export default class PRSCostItem extends React.Component {

  state = {
    edit: false,
    add: false
  }

  handleEditClick = e => {
    e.preventDefault();
    this.setState({edit: true});
  }

  handleAddClick = (e) => {
    e.preventDefault();
    this.setState({add: true});
  }

  cancelEdit = () => {
    this.setState({edit: false});
  }

  cancelAdd = () => {
    this.setState({add: false});
  }

  render() {

    const {
      data,
      pmnts,
      updtBlnc,
      editPost,
      addSets,
      srvcs,
      srvgs,
      ctypes,
      comps,
      tab
    } = this.props;
    let pmntSum = 0;
    let payedSum = 0;
    let earliest = moment().add(1, 'years').format('Y-MM-DD');
    pmnts.forEach(pmnt => {
      pmntSum += pmnt.post_price * pmnt.post_qntt;
      if (pmnt.post_payed) {
        payedSum += pmnt.post_price * pmnt.post_qntt;
      }
      else if (earliest > pmnt.post_bdate) {
        earliest = pmnt.post_bdate;
      }
    });
    const { edit, add } = this.state;
    const pColor = pmntSum === payedSum ? 'green' :
      (earliest <= moment().format('Y-MM-DD') ? 'red' : 'black');
    if (edit){
      return (
        <PRSEditCostForm
          data={data}
          cancelEdit={this.cancelEdit}
          updtBlnc={updtBlnc}
          editPost={editPost}
          addSets={addSets}
          srvgs={srvgs}
          ctypes={ctypes}
          comps={comps}
        />
      );
    }
    else{
      return (
        <tr className="text-info" onClick={this.handleEditClick}>
          <td></td>
          <td className="hover-popup-container">
            {data.post_desc}
            <div onClick={e => e.stopPropagation()}>
              <div
                className="hover-popup"
              >
                <button
                  className="btn btn-success"
                  onClick={this.handleAddClick}
                >
                  Добавить оплату
                </button>
              </div>
              {add && (
                <PRSAddPmntForm
                  data={{
                    post_srvc_id: 0,
                    post_desc: '',
                    post_order_id: data.post_order_id,
                    post_price: data.post_price * data.post_qntt - pmntSum,
                    post_qntt: 1,
                    post_note: "",
                    post_active: 1,
                    post_seller: data.post_seller,
                    post_payer: data.post_payer,
                    post_bdate: data.post_bdate,
                    post_avans: 1,
                    post_payed: 0,
                    post_link: data.post_id
                  }}
                  cancelAdd={this.cancelAdd}
                  costDesc={data.post_desc}
                  updtBlnc={updtBlnc}
                  editPost={editPost}
                  srvcs={srvcs}
                />
              )}
            </div>
          </td>
          <td className="text-right">{fnum(data.post_price)}</td>
          <td className="text-right">{fnum(data.post_qntt)}</td>
          <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
          <td></td>
          <td></td>
          <td>
            {tab === 'cost' && (
              <span style={{color:pColor}}>
                {pmntSum !== payedSum && `Оплатить ${moment(earliest).format('L')}`}
              </span>
            )}
            {data.post_note && <div>{data.post_note}</div>}
          </td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSCostItem.js